import { c as _c } from "react/compiler-runtime";
import { SortType, TourSortView } from "@website/accommodation-ui/tour-result-header/tour-sort-view";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { numberConvert } from "@website/utils/number-convert";
interface Properties {
  desc: string;
  setFilterOpen: () => void;
  selectedFiltersCount: number;
  sorts: Array<SortType>;
}
export const TourResultHeader = properties => {
  const $ = _c(16);
  const {
    setFilterOpen,
    desc,
    selectedFiltersCount,
    sorts
  } = properties;
  let t0;
  if ($[0] !== desc) {
    t0 = <h2 className="text-on-surface-high-emphasis min-w-fit flex-1 font-medium max-lg:hidden max-lg:pt-4">{desc}</h2>;
    $[0] = desc;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MaterialIcon className="text-sm" name="tune" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== selectedFiltersCount) {
    t2 = selectedFiltersCount ? `فیلترها (${numberConvert(selectedFiltersCount, {
      locale: "fa"
    })})` : "\u0641\u06CC\u0644\u062A\u0631\u0647\u0627";
    $[3] = selectedFiltersCount;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== setFilterOpen || $[6] !== t2) {
    t3 = <div className="xl:!hidden"><Button variant="round-outline" color="neutral" size="small" StartIcon={t1} onClick={setFilterOpen}>{t2}</Button></div>;
    $[5] = setFilterOpen;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== sorts) {
    t4 = <TourSortView orderBy="order_by" sorts={sorts} />;
    $[8] = sorts;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <div className="max-lg:bg-on-color-high-emphasis flex gap-2 max-lg:order-1 max-lg:-mx-6 max-lg:w-screen max-lg:px-6 max-lg:py-2">{t3}{t4}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t0 || $[14] !== t5) {
    t6 = <div className="border-outline-thin md:bg-on-color-high-emphasis flex flex-wrap items-center justify-between gap-2 rounded-lg lg:border lg:p-3">{t0}{t5}</div>;
    $[13] = t0;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};